// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__2i020","number":"styles_number__3PrDU"};